import React, { FC } from 'react'
import { useTranslate } from '@/utils/translate/translate-client'
import { getSoloMioIntroText, getSoloMioPrizeText } from '../../giveaway-prizes/projects'

export const SoloMioDetailsContent: FC = () => {
  const { t } = useTranslate('tickets')
  return (
    <div className="mt-2 grid gap-14">
      {getSoloMioIntroText(t)}
      {getSoloMioPrizeText(t)}
    </div>
  )
}
